import {all, call, select} from 'redux-saga/effects';

import {getCategoryId, getIsCategoryFulfilled} from 'selectors/category/category';

import {sendCategoryAnalytics} from '../../homeTryOn/analytics/category/categoryAnalytics';
import {sendDataLayerData} from '../../category/analytics';

/**
 * Send analytics for category page
 * @param {number} id - id current page
 */
export function* sendAnalyticsForCategoryPage(id: number) {
    const [categoryId, isCategoryFulfilled] = yield all([
        select(getCategoryId),
        select(getIsCategoryFulfilled),
    ]);
    if (id === categoryId && isCategoryFulfilled)
        yield all([call(sendCategoryAnalytics), call(sendDataLayerData)]);
}
